import { Component, Input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DisplayPricePipe } from '../../pipes/displayPrice';
import { AvailabilityDebugviewComponent } from "../availability-debugview/availability-debugview.component";
import { formatRateNamePipe } from '../../pipes/format-rate-name.pipe';
import { TruncatedTextComponent } from "../truncated-text/truncated-text.component";
import { SettingsService } from 'core-lib';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-availability-room-1-rate',
    imports: [ButtonModule, DisplayPricePipe, TranslateModule, AvailabilityDebugviewComponent, formatRateNamePipe, TruncatedTextComponent, TooltipModule],
    templateUrl: './availability-room-1-rate.component.html',
    styleUrl: './availability-room-1-rate.component.scss'
})
export class AvailabilityRoom1RateComponent {
  @Input() rate:any;
  onSelect = output<any>();
  truncateHeight:number|undefined;

  constructor(protected settings: SettingsService) {

  }

  ngOnInit(){
    this.truncateHeight = this.settings.get('availability.rateDescriptionMaxHeight');
  }

  selectRate($event:any) {
    this.onSelect.emit($event);
  }
  
}
